var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLowerlimbFemaleFrontFe8E87394CD2Ba4326A54EBa492Fe6Df73(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-src": "blob:http://localhost:8080/4e85ef00-5623-431a-9ecc-1ed03d32b8cb",
    src: "",
    className: "injected-svg",
    fill: "none",
    viewBox: "0 0 348 337",
    height: 337,
    width: 348,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "mask0_8482_6489",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 348,
    height: 337
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 348,
    height: 337,
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    mask: "url(#mask0_8482_6489)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 22.9389C200 22.9389 213.386 17.6181 214 18.4385C214.614 19.2588 217 35.7984 217 37.4392C217 39.08 207.573 39.7625 199.5 40.439C191.427 41.1154 180.5 48.9386 180.5 48.9386L180 42.9386C180 42.9386 186.9 33.4385 190.5 29.4385C194.1 25.4385 200 22.9389 200 22.9389Z",
    fill: "#5A52C3",
    "data-feature-id": "FE.1ebe2e4b-f76d-48c8-ac8e-e5701f6c04ac"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.11 22.6551C154.11 22.6551 140.677 17.4166 140.085 18.1329C139.492 18.8491 137.514 37.4236 137.5 38.9384C137.486 40.4533 143.808 39.2729 151.5 40.4381C159.192 41.6034 174.5 48.4385 174.5 48.4385L174.5 42.4385C174.5 42.4385 168.5 33.9385 164.5 29.4385C160.5 24.9385 154.11 22.6551 154.11 22.6551Z",
    fill: "#D0CEE3",
    "data-feature-id": "FE.9ff578d2-c6ed-4c8c-bcbd-176b9116dfb2"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.665 267.95L166.171 275.042H154.519C154.519 267.443 152.999 263.593 152.999 260.351C152.999 256.298 150.973 243.126 149.959 237.046C148.946 230.967 144.893 203.609 144.387 189.931C143.981 178.988 145.569 174.225 146.413 173.212C153.675 172.705 168.502 173.111 169.718 178.785C171.237 185.877 170.224 191.957 169.718 198.543C169.312 203.812 168.535 220.665 168.198 228.433L165.665 267.95Z",
    fill: "#D0CEE3",
    "data-feature-id": "FE.c74dea52-678e-4ec0-b20e-97bcca3f42f0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M208.221 170.171L185.929 172.704C186.267 169.327 186.943 161.964 186.943 159.532C186.943 156.492 185.929 152.439 185.929 149.4C185.929 146.968 186.267 141.631 186.436 139.267C193.529 139.267 207.613 138.659 207.207 140.281C206.701 142.307 207.207 152.439 207.207 158.012C207.207 162.47 207.545 167.638 208.221 170.171Z",
    fill: "#D0CEE3",
    "data-feature-id": "FE.1424f825-38a7-458a-9681-fbfe7376eb03"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.919 170.172L169.21 172.705C168.873 169.328 168.197 161.965 168.197 159.533C168.197 156.494 169.21 152.441 169.21 149.401C169.21 146.969 168.873 141.633 168.704 139.269C161.611 139.269 146.514 139.674 146.919 141.295C147.426 143.322 147.932 152.441 147.932 158.013C147.932 162.472 147.595 167.639 146.919 170.172Z",
    fill: "#D0CEE3",
    "data-feature-id": "FE.e3c034be-455a-49cb-a73a-835af86dfaf1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M189.476 267.442L188.758 274.695H200.411C200.411 267.096 201.931 263.245 201.931 260.003C201.931 255.95 203.957 242.778 204.97 236.698C205.984 230.619 210.036 203.262 210.543 189.583C210.948 178.64 209.361 173.878 208.517 172.864C201.128 172.864 185.755 173.717 185.212 176.25C183.692 183.343 184.706 191.609 185.212 198.195C185.617 203.464 186.394 220.318 186.732 228.086L189.476 267.442Z",
    fill: "#D0CEE3",
    "data-feature-id": "FE.13620c49-0db3-4033-bb79-7d916f692979"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M217.34 49.5957L180.863 51.1156C180.863 61.5857 181.066 83.9445 181.877 89.6186C182.89 96.7113 183.903 111.91 184.916 117.989C185.727 122.853 186.267 131.499 186.436 135.214L208.221 136.228C208.558 134.032 209.335 128.831 209.741 125.589C210.247 121.536 211.767 104.311 211.767 101.778C211.767 99.2444 215.313 78.9796 215.313 74.9267C215.313 71.6843 216.664 56.6884 217.34 49.5957Z",
    fill: "#D0CEE3",
    "data-feature-id": "FE.c87b1482-7b9f-4bbd-b449-8cc1f98741c3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.8 49.5957L174.277 51.1156C174.277 61.5857 174.074 83.9445 173.264 89.6186C172.251 96.7113 171.237 111.91 170.224 117.989C169.414 122.853 168.873 131.499 168.704 135.214L146.92 136.228C146.582 134.032 145.805 128.831 145.4 125.589C144.893 121.536 143.373 104.311 143.373 101.778C143.373 99.2444 139.827 78.9796 139.827 74.9267C139.827 71.6843 138.476 56.6884 137.8 49.5957Z",
    fill: "#D0CEE3",
    "data-feature-id": "FE.bdbebe0f-da42-4738-a99d-51711e5a333b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M201.015 277.214L186.852 277.004",
    stroke: "#A5A4A4",
    strokeWidth: 0.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.75 1.75"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M155.626 36.5078C156.082 48.7296 159.161 145.339 159.229 146.433C159.298 147.526 155.812 259.559 160.877 277.005",
    stroke: "#A5A4A4",
    strokeWidth: 0.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.75 1.75"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.681 277.214L168.072 277.004",
    stroke: "#A5A4A4",
    strokeWidth: 0.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.75 1.75"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M214.47 17.9551C214.47 17.9551 204.225 20.1955 196.288 24.8276C187.851 29.756 184.292 37.5088 183.249 39.0528",
    stroke: "#A5A4A4",
    strokeWidth: 0.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.75 1.75"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M140.621 17.9551C140.621 17.9551 150.863 20.1955 158.8 24.8276C167.24 29.756 170.796 37.5088 171.84 39.0528",
    stroke: "#A5A4A4",
    strokeWidth: 0.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.75 1.75"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M217.075 38.6318C217.075 38.6318 192.276 42.5319 175.446 42.0192C158.615 41.5065 137.847 39.8854 137.847 39.8854",
    stroke: "#A5A4A4",
    strokeWidth: 0.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.75 1.75"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M144.029 4C142.251 8.77136 137.375 26.3869 137.675 36.4749C137.956 45.8635 139.785 79.6572 141.05 86.3756C142.316 93.094 146.571 137.506 147.529 142.432C148.486 147.357 148.35 164.463 146.023 172.127C143.697 179.791 144.79 201.042 145.751 209.071C146.488 215.27 154.096 268.322 154.369 271.33C154.641 274.338 154.819 276.62 154.819 277.168C154.819 277.716 152.665 278.65 154.369 282.277C154.43 282.432 154.523 282.572 154.64 282.69C154.758 282.808 154.899 282.9 155.053 282.962C155.053 282.962 151.429 298.965 151.153 303.351C150.877 307.737 147.923 319.319 150.54 320.866C152.045 321.755 152.866 320.569 152.866 320.569C152.866 320.569 152.253 324.834 155.361 324.194C157.86 323.681 155.258 327.368 158.372 327.857C159.466 328.026 160.803 327.104 160.803 327.104C160.803 327.104 162.744 330.82 164.522 328.049C165.918 325.877 164.631 329.875 168.463 329.499C170.221 329.324 172.091 329.567 170.858 316.566C169.625 303.564 167.165 283.042 167.165 283.042C167.165 283.042 170.247 278.937 166.143 276.984C166.004 273.94 165.384 268.058 165.592 265.939C165.799 263.82 169.394 197.945 169.969 189.994C170.609 181.169 167.515 163.346 168.327 157.768C170.153 145.226 167.9 148.042 168.671 132.939C169.512 116.4 172.227 99.8895 172.636 89.0102C173.045 78.1309 175.345 44.4024 174.933 42.5532C174.933 42.5532 176.246 43.6141 177.511 43.5578C178.398 43.5945 179.266 43.3022 179.95 42.7369C179.541 44.5832 181.844 78.1309 182.253 89.0102C182.662 99.8895 185.379 116.4 186.221 132.939C186.992 148.054 184.739 145.226 186.565 157.768C187.377 163.346 184.283 181.18 184.923 189.994C185.498 197.945 189.096 263.817 189.3 265.939C189.505 268.061 188.548 273.94 188.411 276.984C184.615 279.059 187.727 283.042 187.727 283.042C187.727 283.042 185.264 303.567 184.034 316.566C182.804 329.564 184.671 329.309 186.429 329.499C190.26 329.875 188.974 325.877 190.37 328.049C192.148 330.82 194.089 327.104 194.089 327.104C194.089 327.104 195.426 328.026 196.52 327.857C199.634 327.368 197.032 323.681 199.531 324.194C202.639 324.834 202.026 320.569 202.026 320.569C202.026 320.569 202.847 321.755 204.352 320.866C206.969 319.319 204.011 307.728 203.736 303.351C203.46 298.974 199.839 282.962 199.839 282.962C200.13 282.808 200.368 282.569 200.52 282.277C202.47 278.993 200.043 277.535 200.043 276.972C200.043 276.409 200.248 274.341 200.52 271.341C200.793 268.342 208.404 215.282 209.141 209.083C210.099 201.054 211.195 179.799 208.869 172.139C206.542 164.478 206.406 147.369 207.363 142.444C208.321 137.518 212.573 93.1059 213.842 86.3875C215.11 79.669 218.062 45.8428 217.214 36.4867C216.029 23.4826 212.973 9.91825 210.863 4.01184",
    stroke: "black",
    strokeWidth: 0.748763,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M182.407 39.5277C182.407 39.5277 180.288 42.5801 179.811 42.8765C179.334 43.1729 177.07 44.4531 174.948 42.5801C173.652 41.4229 172.513 40.1007 171.56 38.6475",
    stroke: "black",
    strokeWidth: 0.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 148.157C201.768 148.157 198.212 151.85 195.473 151.305C193.798 150.947 192.271 150.088 191.096 148.842",
    stroke: "black",
    strokeWidth: 0.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M164.839 148.157C164.839 148.157 161.283 151.85 158.545 151.305C156.868 150.948 155.34 150.089 154.165 148.842",
    stroke: "black",
    strokeWidth: 0.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M189.721 327.432V323.588",
    stroke: "black",
    strokeWidth: 0.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M194.107 327.123V323.588",
    stroke: "black",
    strokeWidth: 0.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M198.318 324.36V321.399",
    stroke: "black",
    strokeWidth: 0.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M202.043 320.589L201.768 317.886",
    stroke: "black",
    strokeWidth: 0.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M165.352 327.652V323.809",
    stroke: "black",
    strokeWidth: 0.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M160.965 327.341V323.809",
    stroke: "black",
    strokeWidth: 0.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M156.502 324.575V321.617",
    stroke: "black",
    strokeWidth: 0.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M153.029 320.808L153.304 318.105",
    stroke: "black",
    strokeWidth: 0.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.74 289.158C153.557 289.925 153.353 290.728 153.139 291.569C152.754 293.087 152.337 294.728 151.957 296.506C150.989 301.033 150.408 306.06 149.756 311.701C149.585 313.184 149.408 314.708 149.219 316.278C149.164 316.737 149.149 319.571 150.436 320.84C150.746 321.147 151.122 321.112 151.484 321.078C152.203 321.01 152.869 320.948 152.869 323.578C153.262 323.925 153.678 323.935 154.101 323.944C155.027 323.964 155.989 323.985 156.823 327.532C157.591 328.044 158.305 327.856 159.011 327.67C159.982 327.415 160.937 327.163 161.994 328.749C163.397 329.593 163.843 328.666 164.163 328.002C164.405 327.498 164.575 327.145 165.036 327.837C166.253 329.662 168.078 329.966 169.903 329.053C172.625 327.692 169.459 301.82 167.722 289.158H159.847H153.74Z",
    fill: "#D0CEE3",
    "data-feature-id": "FE.06ff9043-7031-40f4-8151-e24119525a73"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.102 289.158C201.285 289.925 201.489 290.728 201.702 291.569C202.088 293.087 202.505 294.728 202.885 296.506C203.853 301.033 204.434 306.06 205.086 311.701C205.257 313.184 205.433 314.708 205.623 316.278C205.678 316.737 205.693 319.571 204.406 320.84C204.095 321.147 203.72 321.112 203.358 321.078C202.639 321.01 201.973 320.948 201.973 323.578C201.58 323.925 201.164 323.935 200.74 323.944C199.815 323.964 198.853 323.985 198.018 327.532C197.251 328.044 196.537 327.856 195.831 327.67C194.86 327.415 193.905 327.163 192.847 328.749C191.444 329.593 190.998 328.666 190.679 328.002C190.436 327.498 190.267 327.145 189.806 327.837C188.589 329.662 186.764 329.966 184.939 329.053C182.216 327.692 185.383 301.82 187.12 289.158H194.995H201.102Z",
    fill: "#D0CEE3",
    "data-feature-id": "FE.1ec2659b-e994-4b60-81ce-306cccfcd644"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M199.997 276.993L188.439 276.688L186.614 278.514V281.251C186.614 282.569 188.134 282.772 187.526 284.597C186.918 286.422 200.606 286.118 200.302 285.205C199.997 284.293 199.997 283 200.91 281.859C201.822 280.719 201.316 277.601 199.997 276.993Z",
    fill: "#D0CEE3",
    "data-feature-id": "FE.de3e6dfb-9906-4f75-8621-f6f7965e6d01"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M199.997 276.993L188.439 276.688L186.614 278.514V281.251C186.614 282.569 188.134 282.772 187.526 284.597C186.918 286.422 200.606 286.118 200.302 285.205C199.997 284.293 199.997 283 200.91 281.859C201.822 280.719 201.316 277.601 199.997 276.993Z",
    stroke: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M154.834 276.993L166.393 276.688L168.218 278.514V281.251C168.218 282.569 166.697 282.772 167.305 284.597C167.913 286.422 154.226 286.118 154.53 285.205C154.834 284.293 154.834 283 153.921 281.859C153.009 280.719 153.516 277.601 154.834 276.993Z",
    fill: "#D0CEE3",
    "data-feature-id": "FE.e4748f99-50ff-49b3-9e81-8fa23fe59654"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M154.834 276.993L166.393 276.688L168.218 278.514V281.251C168.218 282.569 166.697 282.772 167.305 284.597C167.913 286.422 154.226 286.118 154.53 285.205C154.834 284.293 154.834 283 153.921 281.859C153.009 280.719 153.516 277.601 154.834 276.993Z",
    stroke: "black"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M199.077 36.5078C198.621 48.7296 195.542 145.339 195.473 146.433C195.405 147.526 198.997 259.559 193.932 277.005",
    stroke: "#A5A4A4",
    strokeWidth: 0.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.75 1.75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerlimbFemaleFrontFe8E87394CD2Ba4326A54EBa492Fe6Df73);
export default __webpack_public_path__ + "static/media/lowerlimb_female_front_FE.8e87394c-d2ba-4326-a54e-ba492fe6df73.05f47b0d65db4b323463ad68943d24b1.svg";
export { ForwardRef as ReactComponent };